var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.75H3.75A.75.75 0 003 7.5v12c0 .414.337.75.75.75h16.5a.75.75 0 00.75-.75v-12a.75.75 0 00-.75-.75zM15.75 6.75v-1.5a1.5 1.5 0 00-1.5-1.5h-4.5a1.5 1.5 0 00-1.5 1.5v1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.842a17.919 17.919 0 01-9 2.408 17.917 17.917 0 01-9-2.408M10.875 11.25h2.25"
  })));
}
export default SvgBriefcase;